import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  digitalizationsController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    'digitalizationService',
    '$filter',
    '$state',
    '$controller',
    'EQuickAccessItems',
    '$interval',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      digitalizationService,
      $filter,
      $state,
      $controller,
      EQuickAccessItems,
      $interval
    ) {
      'use strict';

      let loadingStartTime = null;

      // eslint-disable-next-line no-unused-vars
      function itemsFilter(item) {
        return true;//item.idStatus === EDocumentStatus.IN_CHECKOUT;
      }

      function goToPage(page) {
        $state.go('home.digitalizations', { page: page });
      }

      function loadDocuments(isAutoRefresh = false) {
        if ($scope.currentPage < 1) {
          $scope.goToPage(1);
        } else {
          $rootScope.currentDocument = null;
          $scope.count = 0;
          $scope.description = 'LOADING DOCUMENTS';
          $scope.documents(null);

          if (isAutoRefresh) {
            $scope.refreshing = true;
          } else {
            $scope.loading = true;
          }

          $scope.showOverlay = true;
          loadingStartTime = new Date().getTime();

          var folderColumn = $scope.columns.filter((c) => c.id === 'folder')[0];
          if (folderColumn !== undefined && folderColumn !== null)
            folderColumn.disabled = false;

          digitalizationService.cancelLoadDigitalizations();
          $rootScope.$broadcast('loadFolder', EQuickAccessItems.DIGITALIZATIONS);

          digitalizationService
            .loadDigitalizations($scope.currentPage, $scope.pageSize)
            .then(
              function (data) {
                $scope.count = data.length;
                $scope.totalItem = $scope.count;

                if ($scope.totalItem > $scope.limite) {
                  $scope.limiteValor = $scope.limite;
                  $scope.botaoAtivo = true; //Mostra o botão caso necessario
                } else {
                  $scope.limiteValor = $scope.totalItem;
                  $scope.botaoAtivo = false;
                }

                $scope.pageCount = Math.ceil($scope.count / $scope.pageSize);
                $scope.loading = false;

                if ($scope.pageCount < $scope.currentPage && $scope.count > 0) {
                  $scope.goToPage($scope.pageCount);
                } else {
                  $scope.documents(data);
                  $scope.groups = [];

                  $scope.description = $scope.getDescription(
                    $scope.currentPage,
                    $scope.pageSize,
                    $scope.count
                  );

                  var title = $scope.columns.filter(function (c) {
                    return c.id === 'title';
                  })[0];
                  title.sorted = '';
                  $scope.sortColumn(title);

                  finishLoading();
                }
              },
              function (data) {
                // jscs:disable requireCamelCaseOrUpperCaseIdentifiers

                if (
                  data.status_code === 500 &&
                  $scope.selectedTreeItem.Name === 'CHECKOUTS'
                ) {
                  $scope.documents([]);
                  return;
                }
                swal.fire(data.error, data.error_description);
                // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
                finishLoading();
              }
            );
        }
      }

      function configColumnsEx() {
        $scope.columns = [
          {
            id: 'icon',
            width: '3%',
            header: $filter('translate')('COLUMN.ICON'),
            expression: 'getIcon()',
            style: {
              margin: '0',
              padding: '4.0px',
              display: 'flex !important',
              'justify-content': 'center',
              'align-items': 'center',
              'text-overflow': 'clip',
              'max-width': '3px',
              'text-align': 'center !important',
            },
            hideHeader: true,
            visible: true,
            disabled: false,
            dataPriority: 1,
          },
          {
            id: 'title',
            width: $scope.isAutologin() ? '25%' : '30%',
            header: $filter('translate')('COLUMN.TITLE'),
            expression: 'formatedTitle()',
            style: {
              'min-width': '20px',
            },
            sortExpression: 'title',
            tooltip: 'tooltipTitle()',
            dataPriority: 1,
            visible: true,
            disabled: false,
            sortable: true,
            type: 'text',
          },
          {
            id: 'author',
            header: $filter('translate')('COLUMN.AUTHOR'),
            expression: 'author.Name',
            style: {
              'min-width': '80px',
            },
            width: '10%',
            mobileShow: false,
            visible: true,
            dataPriority: 6,
            disabled: false,
            sortable: true,
            type: 'text',
          },
          {
            id: 'date',
            header: $filter('translate')('COLUMN.DATE'),
            expression: 'formatedDate()',
            sortExpression: 'date',
            style: {
              'min-width': '85px',
            },
            width: '8%',
            mobileShow: false,
            visible: true,
            dataPriority: 5,
            disabled: false,
            sortable: true,
            type: 'date',
          },
          {
            id: 'size',
            header: $filter('translate')('COLUMN.SIZE'),
            expression: 'formatedSize()',
            sortExpression: 'size',
            style: {
              'min-width': '100px',
            },
            width: '10%',
            mobileShow: false,
            visible: true,
            dataPriority: 6,
            disabled: false,
            sortable: true,
            type: 'number',
          },
          {
            id: 'status',
            width: '11%',
            header: 'Status',
            expression: 'getDigitalizationStatus()',
            style: {
              'min-width': '80px',
            },
            dataPriority: 1,
            hideHeader: false,
            visible: true,
            disabled: false,
          },
        ];
      }

      let intervalPromise = null;
      let isLoadingAutoRefresh = false;

      function startAutoRefresh() {
        if (intervalPromise) return;

        intervalPromise = $interval(async () => {
          if (isLoadingAutoRefresh) return;

          isLoadingAutoRefresh = true;

          try {
            await $scope.loadDocuments(true);
          } finally {
            isLoadingAutoRefresh = false;
          }
        }, 10000);
      }

      function stopAutoRefresh() {
        if (intervalPromise) {
          $interval.cancel(intervalPromise);
          intervalPromise = null;
        }
      }

      $scope.$on('$destroy', function () {
        if (intervalPromise) {
          $interval.cancel(intervalPromise);
          intervalPromise = null;
        }
      });

      $scope.$on('STOP_AUTO_REFRESH', function () {
        stopAutoRefresh();
      });

      $scope.$on('RESUME_AUTO_REFRESH', function () {
        startAutoRefresh();
        $scope.loadDocuments();
      });

      $scope.$on('RELOAD_DIGITALIZATIONS', function () {
        $scope.loadDocuments();
      });

      function finishLoading() {
        const EXTRA_TIME = 2000;

        setTimeout(() => {
          $scope.loading = false;
          $scope.refreshing = false;
          $scope.showOverlay = false;

          if (loadingStartTime) {
            loadingStartTime = null;
          }

          if (!$scope.$$phase) {
            $scope.$applyAsync();
          }
        }, EXTRA_TIME);
      }

      function run() {
        try {
          $controller('baseController', { $scope: $scope });
          $controller('chatbotController', { $scope: $scope });

          $scope.loading = false;
          $scope.refreshing = false;
          $scope.showOverlay = false;

          $rootScope.$broadcast('clearSearchTerm');
          $scope.autologincolumns = ['icon', 'title', 'description'];
          $scope.title = $filter('translate')('PROCESSING');
          $scope.description = '';
          $scope.noDocuments = $filter('translate')('NO PROCESSING');
          $scope.noDocumentsMessage = $filter('translate')('NO PROCESSING MSG');

          if (!$state.params.page) {
            $state.go('home.digitalizations', { page: 1 });
          }

          $scope.currentPage = $state.params.page
            ? parseInt($state.params.page)
            : 1;

          $scope.pageSize = 100;
          $scope.pageCount = 1;
          $scope.groups = null;
          $scope.currentGroup = null;
          $scope.columns = [];
          $scope.canView = false;
          $scope.loading = true;
          $scope.count = 0;
          $scope.valueCanSendByEmail = false;
          $scope.checkCanSendByEmail = true;

          $scope.itemsFilter = logWrapper(
            itemsFilter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.goToPage = logWrapper(
            goToPage,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadDocuments = logWrapper(
            loadDocuments,
            runtimeConstant.isDebugControllersInternals
          );

          configColumnsEx();
          startAutoRefresh();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
